/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  IncidentResponse,
  LogDebugResponse,
  LogEntry,
} from '../models/index';
import {
    IncidentResponseFromJSON,
    IncidentResponseToJSON,
    LogDebugResponseFromJSON,
    LogDebugResponseToJSON,
    LogEntryFromJSON,
    LogEntryToJSON,
} from '../models/index';

export interface LogDebugRequest {
    logEntry?: LogEntry;
}

export interface LogErrorRequest {
    logEntry?: LogEntry;
}

/**
 * 
 */
export class LogApi extends runtime.BaseAPI {

    /**
     * Write debug information to the backend log
     * Report debug information to backend log
     */
    async logDebugRaw(requestParameters: LogDebugRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LogDebugResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/logging/debug`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LogEntryToJSON(requestParameters.logEntry),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LogDebugResponseFromJSON(jsonValue));
    }

    /**
     * Write debug information to the backend log
     * Report debug information to backend log
     */
    async logDebug(requestParameters: LogDebugRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LogDebugResponse> {
        const response = await this.logDebugRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Report an error in the SPA back to the backend and generate an Incident in the backend log
     * Report error to backend log
     */
    async logErrorRaw(requestParameters: LogErrorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IncidentResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/logging/error`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LogEntryToJSON(requestParameters.logEntry),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IncidentResponseFromJSON(jsonValue));
    }

    /**
     * Report an error in the SPA back to the backend and generate an Incident in the backend log
     * Report error to backend log
     */
    async logError(requestParameters: LogErrorRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IncidentResponse> {
        const response = await this.logErrorRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
